import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  InputGroup,
  DropdownButton,
  Dropdown,
  Table,
  Modal,
  Button,
  FormControl,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getCandidates,
  removeCandidate,
  editCandidate,
} from "../../../Slices/adminSlice";
import { useTable, useExpanded } from "react-table";
import OrganizationSearch from "../../../components/OrganizationSearch/OrganizationSearch";
import { showModal } from "../../../Slices/sessionSlice";
import SpinnerButton from "../../../components/SpinnerButton/SpinnerButton";
import CandidateSearchBar from "../../../components/AdminCandidateSearch/AdminCandidateSearch";
import { getDifferenceBetweenArrays } from "../../../helpers/stubs";
import EditCandidateModal from "../../../components/EditCandidateModal/EditCandidateModal";

const EditUserModalId = "EditUser.edit";
const RemoveUserModalId = "EditUser.remove";
function EditUser() {
  const [filterUserBy, setFilterUserBy] = useState("Candidate");
  const [selectedOrganization, setselectedOrganization] = useState(null);
  const dispatch = useDispatch();
  // console.log(filterUserBy, selectedOrganization);
  const { candidates } = useSelector((state) => state.adminSlice);
  const { activeModal } = useSelector((state) => state.sessionSlice);
  const [candidatesSupervisingOld, setCandidatesSupervisingOld] = useState([]);
  const [candidatesSupervising, setCandidatesSupervising] = useState([]);
  useEffect(() => {
    if (selectedOrganization) {
      dispatch(
        getCandidates({
          organizationId: selectedOrganization._source._id,
          filterBy: filterUserBy,
        })
      );
    }
  }, [dispatch, filterUserBy, selectedOrganization]);

  const data = React.useMemo(() => {
    return candidates.map((candidateData, index) => {
      const {
        firstName,
        lastName,
        role,
        _id,
        position,
        candidatesSupervising,
        supervisors,
        currency,
        weeklyHours,
        hourlyRate,
      } = candidateData;
      // console.log("candiateData :- ", candidateData);
      return {
        candidateName: <>{`${firstName} ${lastName}`}</>,
        role: <>{role}</>,
        position: <>{!position ? "NOT SET" : position}</>,
        currency: <>{!currency ? "NOT SET" : currency}</>,
        weeklyHours: <>{weeklyHours}</>,
        hourlyRate: <>{hourlyRate}</>,
        candidatesSupervising:
          candidatesSupervising.length > 0 ? (
            <>
              <ul>
                {candidatesSupervising.map((candidate, key) => {
                  return (
                    <li key={key}>
                      <p>{`${candidate.firstName} ${candidate.lastName}`}</p>
                    </li>
                  );
                })}
              </ul>
            </>
          ) : (
            "none"
          ),
        supervisors:
          supervisors.length > 0 ? (
            <>
              <ul>
                {supervisors.map((supervisor, key) => {
                  return (
                    <li key={key}>
                      <p>{`${supervisor.firstName} ${supervisor.lastName}`}</p>
                    </li>
                  );
                })}
              </ul>
            </>
          ) : (
            "none"
          ),
        edit: (
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="blue"
              className="bi bi-pencil-square"
              viewBox="0 0 16 16"
              style={{
                cursor: "pointer",
                width: "16px",
                height: "16px",
                // marginRight: "20px",
              }}
              onClick={() => {
                dispatch(
                  showModal({
                    id: EditUserModalId,
                    data: {
                      name: firstName + " " + lastName,
                      role,
                      _id,
                      candidatesSupervisingOld: candidatesSupervising,
                      supervisorsOld: supervisors,
                      positionOld: position,
                      hourlyRateOld: hourlyRate,
                      weeklyHoursOld: weeklyHours,
                      currencyOld: currency,
                      organization: selectedOrganization,
                      sessionUserRole: "super-admin",
                      editCandidate,
                    CandidateSearchBar
                    },
                  })
                );
              }}
            >
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
              <path
                fillRule="evenodd"
                d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="red"
              className="bi bi-trash"
              viewBox="0 0 16 16"
              style={{ cursor: "pointer", marginLeft: "20px" }}
              onClick={() => {
                dispatch(
                  showModal({
                    id: RemoveUserModalId,
                    data: {
                      candidateId: _id,
                      name: firstName + " " + lastName,
                      role,
                    },
                  })
                );
              }}
            >
              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
              <path
                fillRule="evenodd"
                d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
              />
            </svg>
          </div>
        ),
      };
    });
  }, [candidates]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Candidates",
        accessor: "candidateName",
        width: 50,
      },
      {
        Header: "Position",
        accessor: "position",
        width: 50,
      },
      {
        Header: "CandidatesSupervising",
        accessor: "candidatesSupervising",
        width: 50,
      },
      {
        Header: "Supervisors",
        accessor: "supervisors",
        width: 50,
      },
      {
        Header: "WeeklyHours",
        accessor: "weeklyHours",
        width: 5,
      },
      {
        Header: "Currency",
        accessor: "currency",
        width: 5,
      },
      {
        Header: "HourlyRate",
        accessor: "hourlyRate",
        width: 5,
      },
      {
        Header: "Role",
        accessor: "role",
        width: 50,
      },
      {
        Header: "Edit",
        accessor: "edit",
        width: 50,
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data }, useExpanded);
  // #region EditUserModal
  // const EditUserModal = ({ data }) => {
  //   const {
  //     role,
  //     name,
  //     _id,
  //     organization,
  //     supervisorsOld,
  //     candidatesSupervisingOld,
  //     currencyOld,
  //     weeklyHoursOld,
  //     hourlyRateOld,
  //     positionOld,
  //   } = data;
  //   // console.log(data, "editUserData");
  //   // const [currencyModal, setCurrencyModal] = useState(currency || "INR");
  //   const roles = ["Supervisor", "Candidate", "OrgAdmin"];
  //   const [selectedRole, setselectedRole] = useState(role);
  //   const [candidatesSupervising, setCandidatesSupervising] = useState(
  //     candidatesSupervisingOld || []
  //   );
  //   const [supervisors, setSupervisors] = useState(supervisorsOld || []);
  //   const [position, setPosition] = useState(positionOld || "none");
  //   const [currency, setCurrency] = useState(currencyOld || "Currency");
  //   const [weeklyHours, setWeeklyHours] = useState(weeklyHoursOld || 0);
  //   const [hourlyRate, setHourlyRate] = useState(hourlyRateOld || 0);
  // console.log(supervisors, "supervisors");

  //   const editUser = () => {
  //     const candidates = candidatesSupervising.map(
  //       (candidate) => candidate._id
  //     );
  //     const [removedSupervisors, addedSupervisors] = getDifferenceBetweenArrays(
  //       supervisorsOld,
  //       supervisors,
  //       "_id"
  //     );
  //     const [removedCandidtesSupervising, addedCandidatesSupervising] =
  //       getDifferenceBetweenArrays(
  //         candidatesSupervisingOld,
  //         candidatesSupervising,
  //         "_id"
  //       );
  //     console.log("removedSupervisors", removedSupervisors);
  //     console.log("addedSupervisors", addedSupervisors);

  //     // dispatch(
  //     //   editCandidate({
  //     //     role: selectedRole,
  //     //     candidateId: _id,
  //     //     organizationId: selectedOrganization._source._id,
  //     //     candidatesSupervising: candidates,
  //     //   })
  //     // );
  //   };

  //   return (
  //     <Modal
  //       show={true}
  //       size="xl"
  //       aria-labelledby="contained-modal-title-vcenter"
  //       top
  //       autoFocus
  //       animation
  //     >
  //       <Modal.Header>
  //         <Row className="w-100">
  //           <Modal.Title
  //             id="contained-modal-title-vcenter"
  //           >
  //             Edit Candidate : {name}
  //           </Modal.Title>
  //         </Row>
  //       </Modal.Header>
  //       <Modal.Body>
  //         {/* <Row className="w-100">
  //           <Col sm="12">
  //             <h4
  //               style={{
  //                 marginLeft: "15vw",
  //                 marginTop: "20px",
  //                 marginBottom: "20px",
  //               }}
  //             >
  //               Change User : <span style={{ fontWeight: "bold" }}>{name}</span>{" "}
  //               Role from <span style={{ fontWeight: "bold" }}>{role}</span> to{" "}
  //               <span style={{ fontWeight: "bold" }}>{selectedRole}</span>{" "}
  //             </h4>
  //             {/* <h4 style={{marginLeft:"25vw",marginTop:"20px",marginBottom:"20px"}}>Want To Proceed</h4> */}
  //         {/* </Col> */}
  //         {/* </Row> */}
  //         <Row>
  //           {selectedRole === "Supervisor" && (
  //             <Row>
  //               <Col>
  //                 <InputGroup className="mb-3">
  //                   <InputGroup.Text id="edit-Position">
  //                     CandidatesSupervising
  //                   </InputGroup.Text>
  //                   <CandidateSearchBar
  //                     defaultSelected={candidatesSupervisingOld}
  //                     multiple={true}
  //                     handleSelection={setCandidatesSupervising}
  //                     placeholder={"Assign Candidates For Supervisor"}
  //                     organization={organization}
  //                   />
  //                 </InputGroup>
  //               </Col>
  //             </Row>
  //           )}
  //           {selectedRole === "Candidate" && (
  //             <Row>
  //               <Col>
  //                 <InputGroup className="mb-3">
  //                   <InputGroup.Text id="edit-organisation">
  //                     Supervisors
  //                   </InputGroup.Text>
  //                   <CandidateSearchBar
  //                     defaultSelected={supervisorsOld}
  //                     multiple={true}
  //                     handleSelection={setSupervisors}
  //                     placeholder={"Assign Supervisor For Candidate"}
  //                     organization={organization}
  //                   />
  //                 </InputGroup>
  //               </Col>
  //             </Row>
  //           )}
  //         </Row>
  //         {/* <Row>
  //           <Col>
  //             <InputGroup className="mb-3">
  //               <InputGroup.Text id="edit-organisation">
  //                 Organization
  //               </InputGroup.Text>
  //               <OrganizationSearch
  //                 handleSelection={setselectedOrganization}
  //                 defaultSelected={organization}
  //               />
  //             </InputGroup>
  //           </Col>
  //         </Row> */}
  //         <Row>
  //           <Col>
  //             <InputGroup className="mb-3">
  //               <InputGroup.Text id="edit-Position">Position</InputGroup.Text>
  //               <FormControl
  //                 id="basic-url"
  //                 aria-describedby="basic-addon3"
  //                 value={position}
  //                 onChange={(e) => setPosition(e.target.value)}
  //               />
  //             </InputGroup>
  //           </Col>
  //         </Row>
  //         <Row>
  //           <Col>
  //             <InputGroup className="mb-3">
  //               <InputGroup.Text id="edit-weeklyHours">
  //                 WeeklyHours
  //               </InputGroup.Text>
  //               <FormControl
  //                 id="basic-url"
  //                 aria-describedby="basic-addon3"
  //                 value={weeklyHours}
  //                 onChange={(e) => setWeeklyHours(e.target.value)}
  //               />
  //             </InputGroup>
  //           </Col>
  //         </Row>
  //         <Row>
  //           <Col>
  //             <InputGroup className="mb-3">
  //               <InputGroup.Text id="edit-hourlyRate">
  //                 HourlyRate
  //               </InputGroup.Text>
  //               <FormControl
  //                 id="basic-url"
  //                 aria-describedby="basic-addon3"
  //                 value={hourlyRate}
  //                 onChange={(e) => setHourlyRate(e.target.value)}
  //               />
  //             </InputGroup>
  //           </Col>
  //         </Row>
  //         <Row>
  //           <Col>
  //             <InputGroup className="mb-3">
  //               <DropdownButton
  //                 variant="outline-secondary"
  //                 title={currency}
  //                 id="input-group-dropdown-1"
  //               >
  //                 <Dropdown.Item onClick={() => setCurrency("INR")}>
  //                   INR
  //                 </Dropdown.Item>
  //                 <Dropdown.Item onClick={() => setCurrency("USD")}>
  //                   USD
  //                 </Dropdown.Item>
  //               </DropdownButton>
  //             </InputGroup>
  //           </Col>
  //         </Row>
  //         <ul
  //             id="list"
  //             className="device_title_outer"
  //             style={{
  //               display: "flex",
  //               listStyle: "none",
  //             }}
  //           >
  //             <lable for="list">Select Role:</lable>
  //             {roles.map((role) => (
  //               <li
  //                 className="device_title_inner"
  //                 style={{ marginLeft: "10px" }}
  //               >
  //                 <input
  //                   type="radio"
  //                   eventKey={role}
  //                   value={role}
  //                   name="item"
  //                   id={role}
  //                   checked={selectedRole === role}
  //                   className={"form-check-label"}
  //                   onChange={(e) => {
  //                     setselectedRole(e.target.value);
  //                     setCandidatesSupervising(candidatesSupervisingOld);
  //                     setSupervisors(supervisorsOld);
  //                   }}
  //                 />
  //                 <label style={{ marginLeft: "3px" }} for={role}>
  //                   {role}
  //                 </label>
  //               </li>
  //             ))}
  //           </ul>
  //         <Row>
  //           <Col
  //             sm="12"
  //             style={{
  //               marginLeft: "29vw",
  //               marginTop: "20px",
  //               marginBottom: "20px",
  //             }}
  //           >
  //             <Button variant="outline-success" onClick={() => editUser()}>
  //               Yes
  //             </Button>
  //             <Button
  //               variant="outline-danger"
  //               onClick={() => {
  //                 dispatch(showModal(null));
  //               }}
  //               style={{ marginLeft: "80px" }}
  //             >
  //               No
  //             </Button>
  //           </Col>
  //         </Row>
  //       </Modal.Body>
  //     </Modal>
  //   );
  // };
  // #endregion
  // #region RemoveUserModal
  const RemoveUserModal = ({ data }) => {
    const { candidateId, role, name } = data;
    return (
      <Modal
        show={true}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        top
        autoFocus
        animation
      >
        <Modal.Header>
          <Row className="w-100">
            <Modal.Title
              id="contained-modal-title-vcenter"
              style={{ marginLeft: "30vw" }}
            >
              Confirmation
            </Modal.Title>
          </Row>
        </Modal.Header>
        <Modal.Body>
          <Row className="w-100">
            <Col sm="12">
              <h4
                style={{
                  marginLeft: "15vw",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                Remove User:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {name} ({role})
                </span>{" "}
                from <span style={{ fontWeight: "bold" }}>{}</span>
                <span style={{ fontWeight: "bold" }}>
                  {selectedOrganization._source.name}
                </span>{" "}
              </h4>
              {/* <h4 style={{marginLeft:"25vw",marginTop:"20px",marginBottom:"20px"}}>Want To Proceed</h4> */}
            </Col>
          </Row>
          <Row>
            <Col
              sm="12"
              style={{
                marginLeft: "29vw",
                marginTop: "20px",
                marginBottom: "20px",
              }}
            >
              <SpinnerButton
                variant="outline-success"
                id={"editUser.remove"}
                name="Yes"
                onClick={() => {
                  dispatch(removeCandidate({ candidateId }));
                }}
              />
              <Button
                variant="outline-danger"
                onClick={() => {
                  dispatch(showModal(null));
                }}
                style={{ marginLeft: "80px" }}
              >
                No
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    );
  };
  // #endregion
  return (
    <div style={{ overflowX: "hidden" }}>
      <Row>
        <h2
          style={{ marginLeft: "40vw", padding: "10px", marginBottom: "15px" }}
        >
          Edit Tracker User
        </h2>
      </Row>
      <Row>
        <Col sm="6" style={{ marginLeft: "25vw" }}>
          <InputGroup className="mb-3">
            <DropdownButton
              variant="outline-secondary"
              title={filterUserBy}
              id="input-group-dropdown-1"
            >
              <Dropdown.Item onClick={() => setFilterUserBy("Candidate")}>
                Candidate
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setFilterUserBy("Supervisor")}>
                Supervisor
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setFilterUserBy("OrgAdmin")}>
                OrgAdmin
              </Dropdown.Item>
            </DropdownButton>
            <OrganizationSearch
              handleSelection={setselectedOrganization}
              defaultSelected={null}
            />
          </InputGroup>
        </Col>
      </Row>
      <Row className={"my-4 shadow-sm p-3 mb-5 bg-body rounded text-center"}>
        <Table {...getTableProps()} bordered responsive>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps({
                      style: {
                        minWidth: column.minWidth,
                        width: column.width,
                      },
                    })}
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Row>
      {Boolean(activeModal) && activeModal.id === EditUserModalId && (
        <EditCandidateModal data={activeModal.data} />
      )}
      {Boolean(activeModal) && activeModal.id === RemoveUserModalId && (
        <RemoveUserModal data={activeModal.data} />
      )}
    </div>
  );
}

export default EditUser;
